<template>
  <div id="index">
    <!-- 头部 -->
    <HeaderTop :headIndex="head_index" ref="header"></HeaderTop>

    <!-- 报名表单 -->
    <div class="activitiesDetails">
      <div class="popup_div">
        <div class="popup_center">
          <!-- 轮播图 -->
          <div class="swiper_div">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide flex_center" v-for="(liem, index) in details.file" :key="index">
                  <img :src="liem" alt="" />
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination"></div>
              <!-- Add Arrows -->
              <div class="swiper-button-next flex_center">
                <img src="@/assets/img/button-next.png" alt="" />
              </div>
              <div class="swiper-button-prev flex_center">
                <img src="@/assets/img/button-next.png" alt="" />
              </div>
            </div>
          </div>
          <!-- 内容 -->
          <div class="details_title">
            <span class="tag flex_center">{{ details.activity_id }}号</span>
            {{ details.title }}
          </div>
          <div class="details_center" v-html="details.content"></div>

          <div class="comments_div">
            <div class="comments_ul" v-if="comment.length > 0">
              <div class="hot_div">
                <div class="hot_list">
                  <div class="list_describe">
                    {{comment_total}}条评论
                  </div>
                  <div class="hot_li" v-for="(liem,index) in comment">
                    <div class="li_title flex_between">
                      <div class="name flex_center">
                        <img :src="liem.image" alt="">
                        <h2>{{liem.name}}</h2>
                      </div>
                      <span class="time">{{liem.create_time}}</span>
                    </div>
                    <div class="li_center" v-if="liem.type == 1" v-html="liem.content">

                    </div>
                    <div class="li_center li_r_img" v-if="liem.type == 2">
                      <img :src="liem.content" alt="">
                    </div>
                    <!-- <div class="li_button flex_between">
                            <a class="flex_center" href="javaScript:vido(0)" @click.stop="give(index)">
                                <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                                {{liem.goods}}
                            </a>
                        </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="complete">暂无评论</div>

            <div class="comments_input flex_center">
              <div class="flex_between mian">
                <div class="flex_center give" @click="giveFun">
                  <i><img v-if="details.is_goods == 0" src="@/assets/img/give.png" alt="">
                    <img v-else src="@/assets/img/give_t.png" alt=""></i>
                  {{ details.goods }}
                  <span class="prompt">投票</span>
                </div>
                <div class="input_div flex_center">
                  <i class="expression icon_img"><img src="@/assets/img/smilingT.png" alt="" /></i>
                  <input class="inpu_div" @keyup.enter="out()" type="text" placeholder="说点什么。。。" />
                </div>
                <button class="flex_center send" @click.stop="out">发送</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import "@/assets/js/currency.js";
  import "@/assets/css/reset.css";
  import "@/assets/css/pcsinaFaceAndEffec.css";
  import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
  import Footer from "@/components/assembly/Footer.vue"; //尾部模块
  import comments_li from "@/components/assembly/comments_li.vue"; //评论列表数据模块
  import { AnalyticEmotion, Hashtable } from "@/assets/js/pcsinaFaceAndEffec.js";
  export default {
    name: "activitiesDetails",
    data() {
      return {
        comment_total: 0, //评论数量
        comment: [], //评论列表
        page: 1, //翻页
        head_index: 1,
        details: {},
        details_id: 0,
      };
    },
    computed: {},
    components: {
      comments_li,
      HeaderTop,
      Footer
    },
    props: {
      details_id: {
        type: String,
      },
    },
    watch: {},
    methods: {
      is_judge() {
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.header.promptShow();
          return false;
        }

        return true;
      },
      //   点赞
      giveFun() {
        if (!this.is_judge()) {
          return false;
        }
        let that = this;
        this.$post("activity-goods", {
          activity_id: this.details_id,
          member_id: this.USER().id,
        }).then((res) => {
          if (res.data) {
            layer.open({
              content: "点赞成功",
              time: true,
              skin: "msg",
            });
            that.details.goods = that.details.goods + 1;
            that.details.is_goods = 1;
          }
        }).catch(error => {
          layer.open({
            content: error.message,
            time: 2,
            skin: "msg"
          });
        });
      },
      //   获取详情信息
      getDetails() {
        let that = this;
        this.$post("activity-view", {
          activity_id: this.details_id,
          member_id: this.USER().id,
        }).then((res) => {
           
          if (res.data) {
            res.data.file = res.data.file.split(",");
            that.details = res.data;

            that.$nextTick(() => {
              that.swiperFun();
            });
          }
        });
      },
      out: function () {
        if (!this.is_judge()) {
          return false;
        }
        //发送
        var inputText = $(".inpu_div").val();
        if (!inputText) {
          layer.open({
            content: "请输入内容",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.USER().is_words == 1) {
          layer.open({
            content: "你已被禁言!",
            time: true,
            skin: "msg"
          });
        } else {
          this.send(AnalyticEmotion(inputText));
        }

      },
      send(content) {
        //发送评论
        let that = this;

        this.$post("add-comment", {
          activity_id: this.details_id,
          member_id: this.USER().id,
          content: content,
        }).then((res) => {
          layer.open({
            content: "评论成功",
            time: true,
            skin: "msg",
          });
          $(".inpu_div").val("");
          setTimeout(() => {
            that.page = 1;
            that.getComment();
          }, 1000);
        }).catch(error => {
           
          layer.open({
            content: error.message,
            time: 2,
            skin: "msg"
          });
        });
      },
      getComment() {
        //获取评论
        let that = this;
        if (this.page == 1) {
          this.comment = [];
        }
        this.$post("activity-comment", {
          activity_id: this.details_id,
          limit: 10,
          page: this.page,
        }).then((res) => {
          that.comment_total = res.data.total;
          that.comment = that.comment.concat(res.data.data);
        });
      },
      swiperFun() {
        //实例轮播图
        var swiper = new Swiper(".swiper-container", {
          loop: true,
          pagination: ".swiper-pagination",
          paginationClickable: ".swiper-pagination",
          nextButton: ".swiper-button-next",
          prevButton: ".swiper-button-prev",
          spaceBetween: 0,

        });
      },
    },
    created() { },
    mounted() {
      this.details_id = this.$route.query.id;
      this.getDetails();
      this.getComment();

      $(".expression").SinaEmotion($(".inpu_div"));
      $(".expression").click(function () {
        $("#emotions").css({
          left: "50%",
          width: "436px",
          top: "50%",
          transform: "translate(-50%,-50%)",
          bottom: "auto",
          "z-index": "999",
        });
      });
      if (this._isMobile()) {
        // alert("手机端");
        this.$router.push({ path: '/m_activity', query: { id: this.details_id } });
      } else {
        // alert("pc端");
        // this.$router.replace('/index');
      }
      let that = this;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $(document).height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getComment();
        }
      });

    },
  };
</script>
<style scoped>
  #index {
    padding-bottom: 80px;
  }

  .activitiesDetails {
    max-width: 1280px;
    min-width: 865px;
    margin: 0 auto;
    width: 1280px;
    border-top: 9px solid #da505e;
    /* height: calc(100vh - 140px); */
    overflow: hidden;
    background: #fff;
  }

  .popup_div {
    height: 100%;
    overflow-y: auto;
  }
.prompt{
  font-size: 14px;
  color:#777;
  margin-left: 5px;
}
  /* swiper轮播图 */
  .swiper_div {
    padding: 90px 0;
  }

  .swiper-container {
    width: calc(100% - 140px);
    height: 100%;
  }

  .swiper-wrapper {
    width: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    height: 471px;
    overflow: hidden;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide img {
    width: auto;
    height: 100%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 74px;
    background-image: none;
    /* transform: translateX(-50%); */
  }

  .swiper-button-next {
    /* transform: translateX(50%); */
  }

  .swiper-button-prev img {
    transform: rotate(180deg);
  }

  /* 内容 */
  .details_title {
    padding: 0 70px;
    font-size: 27px;
    color: #2b2b2b;
    font-weight: bold;
    border-bottom: 1px dotted #f4f4f4;
    padding-bottom: 20px;
  }

  .details_title .tag {
    min-width: 75px;
    height: 33px;
    padding: 0 8px;
    border-radius: 6px;
    white-space: nowrap;
    color: #fff;
    font-size: 19px;
    background: #ec865b;
    margin-right: 15px;
    display: inline-flex;
    transform: translateY(-2px);
  }

  .details_center {
    padding: 20px 70px;
    border-bottom: 1px solid #e1e1e1;
    font-size: 24px;
    color: #888;
  }

  /* 评论 */
  .comments_div {
    width: calc(100% - 80px);
    margin: 20px auto;
  }

  .comments_div .comments_input {
    padding: 16px 40px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background: #fff;
    box-shadow: -4px 0 10px rgba(0, 0, 0, .1);
  }

  .comments_input .mian {
    max-width: 1280px;
    min-width: 865px;
    width: 1000px;
  }

  .comments_input .input_div {
    flex: 1;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #999;

    padding: 0 14px;
  }

  .comments_input .input_div .inpu_div {
    flex: 1;
    height: 100%;
    font-size: 14px;
    padding: 0;
  }

  .comments_input .icon_img {
    width: 30px;
    cursor: pointer;
    margin: 0 17px 0 0;
  }

  .comments_input .icon_img.up_img {
    position: relative;
    display: flex;
  }

  .comments_input .icon_img.up_img .inp_img {
    position: absolute;
    top: 0;
    opacity: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    display: inline-block;
    cursor: pointer;
  }

  .comments_input .send {
    width: 81px;
    height: 38px;
    border-radius: 4px;
    background: #f24d5b;
    border: 0;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    margin-left: 40px;
  }

  .complete {
    padding: 60px 0;
  }

  .give {
    font-size: 20px;
    color: #a3a2a7;
    margin-right: 20px;
    cursor: pointer;
  }

  .give img {
    width: 24px;
    margin-right: 6px;
  }


  /* 评论列表 */
  .hot_div {
    width: 100%;
  }


  .hot_list {
    padding: 0 23px;
    border: 1px solid #DFDFDF;
    border-radius: 4px;
  }

  .hot_list .list_describe {
    height: 40px;
    border-bottom: 1px solid #DFDFDF;
    color: #333;
    font-size: 14px;
    line-height: 40px;
    margin-bottom: 17px;
  }

  .hot_list .hot_li {
    margin-bottom: 23px;
  }

  .hot_list .hot_li .li_title .name>img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    object-fit: contain;
    margin-right: 8px;
  }

  .hot_list .hot_li .li_title .name>h2 {
    font-size: 18px;
    color: #3E8CDE;
  }

  .hot_list .hot_li .li_title .time {
    font-size: 12px;
    color: #666;
  }

  .hot_list .hot_li .li_center {
    font-size: 15px;
    color: #1a1a1a;
    line-height: 1.6em;
    margin: 8px 0;
  }

  .hot_list .hot_li .li_center img {
    max-width: 50%;
    cursor: pointer;
  }

  .hot_list .hot_li .li_button>a {
    font-size: 14px;
    color: #999;
  }

  .hot_list .hot_li .li_button>a>i {
    width: 15px;
    margin-right: 2px;
  }

</style>


// WEBPACK FOOTER //
// src/components/pcActivity/activitiesDetails.vue